import styled from 'styled-components';

export const Row = styled.li`
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    text-align: left;
`;

export const Label = styled.label`
    padding-left: 1.125rem;
    font-size: ${({ theme }) => theme.fontSizes[5]};
    line-height: 1.5;
    cursor: pointer;
`;
